import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getProviderPaymentSetting, getClientProviderPaymentList, updateProviderPaymentSetting, getClientAppointmentNotesPayment, getProviderAllTranfer, retrieveProviderBalance, providerPayout } from "../slice/providerPaymentSettingSlice";
import ClientDetailsModal from "../../provider-client-details-model/components/index";
import { providerSendMessage } from "../../provider-chat/slice/providerChatSlice";
import jsPDF from "jspdf";

const ProviderPanelPayment = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    stripe_api_key: "",
    stripe_publishable_key: ""
  });
    const [sortConfig, setSortConfig] = useState({ column: null, direction: "asc" });
    const { providerPaymentSetting, providerPayment , clientList, clientAppointmentNotesPayment, retrieveBalance } = useSelector((state) => state.providerPaymentSetting);
    const [showModal, setShowModal] = useState(false);
    const [showClientModal, setShowClientModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [selectedClient, setSelectedClient] = useState(null);
    const [selectedClientNotesData, setSelectedClientNotesData] = useState(null);
    const [amount, setAmount] = useState("");

    const openClientModal = (id) => {
        setSelectedClient(id);
        setShowClientModal(true);
    };

    const closeClientModal = () => {
        setSelectedClient(null);
        setShowClientModal(false);
    };

    const providerToken = localStorage.getItem("provider_access_token");
    
      useEffect(() => {
        // dispatch(getProviderPaymentSetting(providerToken));
        dispatch(retrieveProviderBalance(providerToken));
        dispatch(getProviderAllTranfer(providerToken));
        dispatch(getClientProviderPaymentList(providerToken));
        dispatch(getClientAppointmentNotesPayment(providerToken));
      }, [dispatch]);

    //   useEffect(() => {
    // if (providerPaymentSetting) {
    //         setFormData({
    //         stripe_api_key: providerPaymentSetting.stripe_api_key || "",
    //         stripe_publishable_key: providerPaymentSetting.stripe_publishable_key || ""
    //     });
    // }
    // }, [providerPaymentSetting]);

    const sortedData = [...clientList].sort((a, b) => {
      if (sortConfig.column === null) return 0;

      const key = sortConfig.column;

      const valA = a[key] ?? "";
      const valB = b[key] ?? "";

      if (!isNaN(valA) && !isNaN(valB)) {
         return sortConfig.direction === "asc"
            ? valA - valB
            : valB - valA;
      } else {
         return sortConfig.direction === "asc"
            ? valA.toString().localeCompare(valB.toString())
            : valB.toString().localeCompare(valA.toString());
      }
   });

    const sortedPaymentData = [...providerPayment].sort((a, b) => {
        if (sortConfig.column === null) return 0;

        const key = sortConfig.column;

        const valA = a[key] ?? "";
        const valB = b[key] ?? "";

        if (!isNaN(valA) && !isNaN(valB)) {
          return sortConfig.direction === "asc"
              ? valA - valB
              : valB - valA;
        } else {
          return sortConfig.direction === "asc"
              ? valA.toString().localeCompare(valB.toString())
              : valB.toString().localeCompare(valA.toString());
        }
    });

    const handleAddVideosModel = async () => {
      setShowAddModal(true);
    };

    const handleCloseAddVideosModal = () => {
      setShowAddModal(false);
    };

    const handleAddVideo = async () => {
      if (!amount) {
        toast.error("Please enter a amount.");
        return;
      }
      // // Call your API or dispatch redux action
      const result  = await dispatch(providerPayout({ token: providerToken, amount: amount, currency : 'usd' }));

      if (result.meta.requestStatus === "fulfilled") {
        toast.success("payout successfully!", {
          position: "top-right",
          autoClose: 2000,
          style: { fontSize: "0.85rem" },
        });

        setAmount("");
        setShowAddModal(false);
      
      } else {
        toast.error("Failed to add video", {
          position: "top-right",
          autoClose: 2000,
          style: { fontSize: "0.85rem" },
        });
      }
    };

   const handleSort = (columnKey) => {
      let direction = "asc";
      if (sortConfig.column === columnKey && sortConfig.direction === "asc") {
         direction = "desc";
      }
      setSortConfig({ column: columnKey, direction });
   };


    const formatDate = (dateString) => {
        const date = new Date(dateString);
        
        const year = date.getFullYear();
        const month = ("0" + (date.getMonth() + 1)).slice(-2); // Month is 0-indexed, so add 1
        const day = ("0" + date.getDate()).slice(-2);
        const hours = ("0" + date.getHours()).slice(-2);
        const minutes = ("0" + date.getMinutes()).slice(-2);
        const seconds = ("0" + date.getSeconds()).slice(-2);
        
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const stripeDate = (dateString) => {
      const date = new Date(dateString * 1000);

      const year = date.getFullYear();
      const month = ("0" + (date.getMonth() + 1)).slice(-2); // Month is 0-indexed
      const day = ("0" + date.getDate()).slice(-2);
      const hours = ("0" + date.getHours()).slice(-2);
      const minutes = ("0" + date.getMinutes()).slice(-2);
      const seconds = ("0" + date.getSeconds()).slice(-2);

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

      // console.log("providerPaymentSetting", providerPaymentSetting);
      // console.log("providerList", providerList);
      console.log("clientList", clientList);

    // const handleUpdateData = async () => {
    //     const result = await dispatch(updateProviderPaymentSetting({ token: providerToken, formData }));
    //     if (result.meta.requestStatus === "fulfilled") {
    //           toast.success("Payment setting updated successfully!", {
    //             position: "top-right",
    //             autoClose: 2000,
    //             style: { fontSize: "0.85rem" },
    //           });
    //           dispatch(getProviderPaymentSetting(providerToken));
    //         } else {
    //           toast.error("Failed to update worktime", {
    //             position: "top-right",
    //             autoClose: 2000,
    //             style: { fontSize: "0.85rem" },
    //           });
    //         }
    // };

      const handleShowModel = (client) => {
        console.log("client", client);
         setShowModal(true);
         setSelectedClientNotesData(client)
         dispatch(getClientAppointmentNotesPayment(client.id));
      };
      const handleCloseModal = () => {
         setShowModal(false);
         setSelectedClientNotesData(null); 
      };

      const handlePayoutShowModel = (client) => {
        console.log("client", client);
         setShowModal(true);
         setSelectedClientNotesData(client)
         dispatch(getClientAppointmentNotesPayment(client.id));
      };
      const handlePayoutCloseModal = () => {
         setShowModal(false);
         setSelectedClientNotesData(null); 
      };

const handleSendNoteAsPDF = async (note) => {

  const pdf = new jsPDF();
  const documentBaseUrl = process.env.REACT_APP_ATTACHMENT_NOTES_IMAGE_BACKEND_URL;

  let y = 20;
  const pageWidth = pdf.internal.pageSize.getWidth();
  const leftMargin = 14;
  const rightMargin = pageWidth - 14;
  const cardPadding = 6;
  const bottomPadding = 10;

  const getBase64ImageFromURL = (url) =>
    new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");
      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };
      img.onerror = (error) => reject(error);
      img.src = url;
    });

  // Load logo
  let logoDataUrl;
  try {
    logoDataUrl = await getBase64ImageFromURL("/assets/images/logo.png");
  } catch (e) {
    console.warn("Failed to load logo image:", e);
  }

  // Header with logo (right side)
  if (logoDataUrl) {
  const imgProps = pdf.getImageProperties(logoDataUrl);
  const imgWidth = 15;
  const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

  // Logo coordinates
  const logoX = pageWidth - imgWidth - leftMargin;
  const logoY = y - 10;

  // Background for logo
  const padding = 2;
  pdf.setFillColor(0, 43, 69); // dark blue background
  pdf.rect(
    logoX - padding,
    logoY - padding,
    imgWidth + padding * 2,
    imgHeight + padding * 2,
    "F"
  );

  // Left: Client name
  pdf.setFontSize(14);
  pdf.setFont(undefined, "bold");
  pdf.text(`Client: ${selectedClientNotesData.client.first_name}`, leftMargin, y);
  pdf.text(`Service: ${selectedClientNotesData.serviceProviderPay.service_name}`, leftMargin, y + 8);

  // Center: Date
  const dateText = `Start Date: ${selectedClientNotesData.start_date}`;
  const dateWidth = pdf.getTextWidth(dateText);
  const centerX = (pageWidth - dateWidth) / 2;
  pdf.setFontSize(12);
  pdf.setFont(undefined, "normal");
  pdf.text(dateText, centerX, y);

  // Right: Logo
  pdf.addImage(
    logoDataUrl,
    'PNG',
    logoX,
    logoY,
    imgWidth,
    imgHeight
  );
}


  y += 20;

  // Calculate card height
  let tempY = y + 10; // Date & Present
  tempY += 10;

  // Notes height
  const notesText = `Notes: ${note.notes || "N/A"}`;
  const splitNotes = pdf.splitTextToSize(notesText, pageWidth - 2 * (leftMargin + cardPadding));
  tempY += splitNotes.length * 6 + 6;

  // Documents height
  if (note.documents) {
    const docs = note.documents.split(",").map(doc => doc.trim()).filter(Boolean);
    if (docs.length > 0) {
      tempY += 8 + docs.length * 8;
    }
  }

  const cardHeight = tempY - y + cardPadding + bottomPadding;

  // Draw card background
  pdf.setFillColor(230, 230, 230);
  pdf.rect(leftMargin, y - cardPadding, pageWidth - 2 * leftMargin, cardHeight, "F");

  // Draw border
  pdf.setDrawColor(200, 200, 200);
  pdf.rect(leftMargin, y - cardPadding, pageWidth - 2 * leftMargin, cardHeight);

  // Add text inside card
  y += 10;
  pdf.text(`Date: ${note.date_of_appointment}`, leftMargin + cardPadding, y);

  const presentText = `Present: ${note.present}`;
  const presentWidth = pdf.getTextWidth(presentText);
  pdf.text(presentText, rightMargin - cardPadding - presentWidth, y);

  y += 10;
  pdf.text(splitNotes, leftMargin + cardPadding, y);
  y += splitNotes.length * 6 + 6;

  if (note.documents) {
    const docs = note.documents.split(",").map(doc => doc.trim()).filter(Boolean);
    if (docs.length > 0) {
      pdf.text("Documents:", leftMargin + cardPadding, y);
      y += 8;

      docs.forEach((doc, idx) => {
        const url = `${documentBaseUrl}/${doc}`;
        pdf.setTextColor(0, 0, 255);
        pdf.textWithLink(`View Document ${idx + 1}`, leftMargin + cardPadding, y, { url });
        pdf.setTextColor(0, 0, 0);
        y += 8;
      });
    }
  }

  // pdf.save(`appointment-note-${note.date_of_appointment}.pdf`);
  const pdfBlob = pdf.output("blob");
const pdfFile = new File([pdfBlob], `appointment-note-${note.date_of_appointment}.pdf`, {
  type: "application/pdf",
});

  const clientId = note.appointment.client_id;

dispatch(
  providerSendMessage({
    input: "",
    id: clientId,
    to_type: "Icommunetech\\Client\\Models\\Client",
    file: pdfFile,
    token: providerToken,
  })
)
  .unwrap()
  .then(() => {
    toast.success("PDF sent successfully!");
  })
  .catch(() => {
    toast.error("Failed to send PDF.");
  });

};



const handleSendAllNoteAsPDF = async (notes) => {
  // console.log("notes", notes);
  // console.log("selectedClientNotesData", selectedClientNotesData);
  // return;
  const documentBaseUrl = process.env.REACT_APP_ATTACHMENT_NOTES_IMAGE_BACKEND_URL;
  const pdf = new jsPDF();
  let y = 20; // vertical position tracker

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const leftMargin = 14;
  const rightMargin = pageWidth - 14;
  const cardPadding = 6;
  const cardMargin = 20; // increased from 10 to 20
  const bottomPadding = 10; // added bottom padding

  // Helper function to load image and convert to base64
  const getBase64ImageFromURL = (url) =>
    new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute('crossOrigin', 'anonymous'); // to avoid CORS if hosted externally
      img.onload = () => {
        var canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = (error) => {
        reject(error);
      };
      img.src = url;
    });

  // Load logo image base64 from public folder
  let logoDataUrl;
  try {
    logoDataUrl = await getBase64ImageFromURL('/assets/images/logo.png');
  } catch (e) {
    console.warn('Failed to load logo image:', e);
  }

  // Draw logo at right side, top aligned with title
// Draw header with client name + service name + logo
if (logoDataUrl) {
  const imgProps = pdf.getImageProperties(logoDataUrl);
  const imgWidth = 15;
  const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

  // Logo coordinates
  const logoX = pageWidth - imgWidth - leftMargin;
  const logoY = y - 10;

  // Background for logo
  const padding = 2;
  pdf.setFillColor(0, 43, 69); // dark blue background
  pdf.rect(
    logoX - padding,
    logoY - padding,
    imgWidth + padding * 2,
    imgHeight + padding * 2,
    "F"
  );

  // Left: Client name
  pdf.setFontSize(14);
  pdf.setFont(undefined, "bold");
  pdf.text(`Client: ${selectedClientNotesData.client.first_name}`, leftMargin, y);
  pdf.text(`Service: ${selectedClientNotesData.serviceProviderPay.service_name}`, leftMargin, y + 8);

  // Center: Date
  const dateText = `Start Date: ${selectedClientNotesData.start_date}`;
  const dateWidth = pdf.getTextWidth(dateText);
  const centerX = (pageWidth - dateWidth) / 2;
  pdf.setFontSize(12);
  pdf.setFont(undefined, "normal");
  pdf.text(dateText, centerX, y);

  // Right: Logo
  pdf.addImage(
    logoDataUrl,
    'PNG',
    logoX,
    logoY,
    imgWidth,
    imgHeight
  );
}


// Adjust Y position for the rest of the content
y += 8;
pdf.setFontSize(12);


  y += 12;

  pdf.setFontSize(12);

notes.forEach((note, index) => {
  const cardStartY = y;

  // Calculate all heights first, without drawing text yet:

  let tempY = y;

  tempY += 10; // Date line
  // Present line same height, so no extra height here, just next line
  tempY += 10;

  // Notes content wrapped text height:
  const notesText = `Notes: ${note.notes}`;
  const splitNotes = pdf.splitTextToSize(notesText, pageWidth - 2 * (leftMargin + cardPadding));
  tempY += splitNotes.length * 6 + 6;

  // Documents links if any:
  if (note.documents) {
    const docs = note.documents
      .split(",")
      .map(doc => doc.trim())
      .filter(Boolean);
    if (docs.length > 0) {
      tempY += 8 + docs.length * 8;
    }
  }

  const cardHeight = tempY - cardStartY + cardPadding + bottomPadding;

  // Draw background first:
  pdf.setFillColor(230, 230, 230);
  pdf.rect(leftMargin, cardStartY - cardPadding, pageWidth - 2 * leftMargin, cardHeight, 'F');

  // Draw border:
  pdf.setDrawColor(200, 200, 200);
  pdf.rect(leftMargin, cardStartY - cardPadding, pageWidth - 2 * leftMargin, cardHeight);

  // Now draw actual text on top:

  y += 10;
  pdf.text(`Date: ${note.date_of_appointment}`, leftMargin + cardPadding, y);

  const presentText = `Present: ${note.present}`;
  const presentTextWidth = pdf.getTextWidth(presentText);
  pdf.text(presentText, rightMargin - cardPadding - presentTextWidth, y);
  y += 10;

  pdf.text(splitNotes, leftMargin + cardPadding, y);
  y += splitNotes.length * 6 + 6;

  if (note.documents) {
    const docs = note.documents
      .split(",")
      .map(doc => doc.trim())
      .filter(Boolean);
    if (docs.length > 0) {
      pdf.text("Documents:", leftMargin + cardPadding, y);
      y += 8;

      docs.forEach((docFile, idx) => {
        const url = `${documentBaseUrl}/${docFile}`;
        pdf.setTextColor(0, 0, 255);
        pdf.textWithLink(`View Document ${idx + 1}`, leftMargin + cardPadding, y, { url });
        pdf.setTextColor(0, 0, 0);
        y += 8;
      });
    }
  }

  y += cardMargin;

    // Check if near bottom of page
    if (y > 270) {
      pdf.addPage();
      y = 20;
      
    }
  });

  // pdf.save("all_notes.pdf");

    const pdfBlob = pdf.output("blob");
const pdfFile = new File([pdfBlob], `all_notes.pdf`, {
  type: "application/pdf",
});
const clientId = selectedClientNotesData.client_id;
  dispatch(
  providerSendMessage({
    input: "",
    id: clientId,
    to_type: "Icommunetech\\Client\\Models\\Client",
    file: pdfFile,
    token: providerToken,
  })
)
  .unwrap()
  .then(() => {
    toast.success("PDF sent successfully!");
  })
  .catch(() => {
    toast.error("Failed to send PDF.");
  });

};




      return (
        <>
            <div className="col-md-12 col-xl-9 mt-4 mt-md-0">
                     <div className="ps-2 ps-lg-4">
                        <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat d-flex align-items-center">
                           My Payments

                            {/* <span class="align-items-end"> { retrieveBalance.available[0].amount } </span> */}
                            <button className="btn btn-danger ms-auto py-2"  onClick={() => handleAddVideosModel()} >
                              <i className="fa fa-user-plus me-1"></i> Collect Payoutes
                            </button>
                        </h4>
                        
                        <div className="table-responsive">
                           <table className="table table-striped table-bordered align-middle text-muted" id="servicesTable">
                              <thead>
                                 <tr>
                                    <th width="20%" className="font-weight-semibold" onClick={() => handleSort("created_at")}>Payment Date<span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                    <th width="" className="font-weight-semibold" onClick={() => handleSort("amount")}>Amount<span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                    <th width="" className="font-weight-semibold" onClick={() => handleSort("amount")}>Provider Charge<span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                    <th width="" className="font-weight-semibold" onClick={() => handleSort("amount")}>Admin Charge<span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                    <th width="" className="font-weight-semibold" onClick={() => handleSort("stripe_payment_id")}>Source Type <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                    <th width="" className="font-weight-semibold" onClick={() => handleSort("amount")}>Txn ID<span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                 </tr>
                              </thead>
                              <tbody>
                                 {sortedPaymentData.length > 0 ? (
                                    sortedPaymentData.map((transfer, index) => {
                                      
                                       return (
                                       <tr key={index}>
                                          <td>{stripeDate(transfer.created)}</td>
                                          <td>{(transfer.amount ) /100 } {transfer.currency} </td>
                                          <td>{(transfer.amount - transfer.application_fee) /100 } {transfer.currency} </td>
                                          <td>{(transfer.application_fee) /100 } {transfer.currency} </td>
                                          <td>{transfer.source_type}</td>
                                          <td>{transfer.id}</td>
                                       </tr>
                                       );
                                    })
                                 ) : (
                                    <tr>
                                       <td colSpan="7" className="text-center">No data found.</td>
                                    </tr>
                                 )}
                              </tbody>
                           </table>
                        </div>
                        {/* <div className="row mb-4 pb-3">
                           <div className="col-sm-12">
                              <div className="bg-light rounded p-4">
                                 <div className="row row-cols-1 row-cols-sm-2 g-1 g-sm-4">
                                    <div className="col">
                                       <div className="mb-3">
                                          <label className="form-label text-primary font-size-16 font-weight-semibold">Stripe API Key</label>
                                          <input
                                            type="text"
                                            name="stripe_api_key"
                                            className="form-control"
                                            placeholder="sk_test_51POCOiKzUUldhXuwtEGf2hVvb5oLJiv"
                                            value={formData.stripe_api_key}
                                            onChange={(e) => setFormData({ ...formData, stripe_api_key: e.target.value })}
                                        />
                                       </div>
                                    </div>
                                    <div className="col">
                                       <div className="mb-3">
                                          <label className="form-label text-primary font-size-16 font-weight-semibold">Stripe Publishable Key</label>
                                          <input
                                            type="text"
                                            name="stripe_publish_key"
                                            className="form-control"
                                            placeholder="sk_test_51POCOiKzUUldhXuwtEGf2hVvb5oLJiv"
                                            value={formData.stripe_publishable_key}
                                            onChange={(e) => setFormData({ ...formData, stripe_publishable_key: e.target.value })}
                                        />
                                       </div>
                                    </div>
                                 </div>
                                 <div className="row">
                                    <div className="col-12 pt-2 text-center text-sm-start">
                                       <button type="submit" className="btn btn-custom-primary font-weight-medium font-size-16 text-capitalize px-4 rounded m-1" onClick={}><span className="d-block py-1">Update</span></button>
                                       <button type="reset" className="btn btn-danger font-weight-medium font-size-16 text-capitalize px-4 rounded m-1"><span className="d-block py-1">Cancel</span></button>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div> */}
                        <h4 className="font-weight-bold text-primary font-size-30 mb-3 pb-1 line-hight-2 border-bottom mt-5 montserrat d-flex align-items-center">
                           Client Payment Received
                        </h4>
                        <div className="table-responsive">
                           <table className="table table-striped table-bordered align-middle text-muted" id="servicesTable">
                              <thead>
                                 <tr>
                                    <th width="" className="font-weight-semibold" onClick={() => handleSort("amount")}>Client Name<span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                    <th width="15%" className="font-weight-semibold" onClick={() => handleSort("amount")}>Service<span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                    <th width="15%" className="font-weight-semibold" onClick={() => handleSort("stripe_payment_id")}>Stripe Payment ID <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                    <th width="10%" className="font-weight-semibold" onClick={() => handleSort("status")}>Status <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                    <th width="15%" className="font-weight-semibold" onClick={() => handleSort("start_date")}>Duration<span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                    <th width="12%" className="font-weight-semibold" onClick={() => handleSort("created_at")}>Payment Date<span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                    <th width="12%" className="font-weight-semibold" onClick={() => handleSort("type")}>Type<span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                    <th width="12%" className="font-weight-semibold">Action<span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                 </tr>
                              </thead>
                              <tbody>
                                 {sortedData.length > 0 ? (
                                    sortedData.map((client, index) => {
                                       const appointment = client.serviceAppointment?.[0];
                                       const typeLabel =
                                       appointment?.type === 'S'
                                          ? 'Subscription'
                                          : appointment?.type === 'H'
                                          ? 'Hourly'
                                          : '—';

                                       return (
                                       <tr key={index}>
                                        <td> 
                                          {/* <td>{client.client?.first_name + ' ' + client.client?.last_name}</td> */}
                                          <button className="btn btn-link p-0 text-decoration-underline"
                                                onClick={() => openClientModal(client.client?.id)}>
                                                {client.client?.first_name}
                                            </button> 
                                            </td>
                                          <td>{client.serviceProviderPay?.service_name || '—'}</td>
                                          <td>{client.stripe_payment_id || '—'}</td>
                                          <td>{client.status || '—'}</td>
                                          <td>
                                             {client.start_date || '—'} {client.end_date ? ' - ' + client.end_date : ''}
                                          </td>
                                          <td>{formatDate(client.created_at)}</td>
                                          <td>{typeLabel}</td>
                                          <td><button className="btn btn-custom-primary me-2" onClick={() => handleShowModel(client)}>Details</button></td>
                                       </tr>
                                       );
                                    })
                                 ) : (
                                    <tr>
                                       <td colSpan="7" className="text-center">No data found.</td>
                                    </tr>
                                 )}
                                 </tbody>
                           </table>
                        </div>
                     </div>
                           {showModal && (
        <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" aria-modal="true" role="dialog">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Appointment Notes</h5>
                <button type="button" className="btn-close" onClick={handleCloseModal} aria-label="Close"></button>
              </div>
              <div className="modal-body">
                {/* <div className="d-flex justify-content-between">
                  <div>
                    <div>
                      <strong>Client:</strong> {selectedClientNotesData.client.first_name}
                    </div>
                    <div className="mt-2">
                      <strong>Service:</strong> {selectedClientNotesData.serviceProviderPay.service_name}
                    </div>
                  </div>  
                 {clientAppointmentNotesPayment?.length > 0 && (
                    <div>
                      <button className="btn btn-custom-primary me-2" onClick={() => handleSendAllNoteAsPDF(clientAppointmentNotesPayment)}>Send All notes to client</button>
                    </div>
                  )}
                </div>  */}

                <div className="row mt-3 text-center">
                  <div className="col-md-4 text-start">
                    <strong>Client:</strong> {selectedClientNotesData.client?.first_name} {selectedClientNotesData.client?.last_name}
                  </div>
                  <div className="col-md-4">
                    <strong>Service:</strong> {selectedClientNotesData.serviceProviderPay.service_name}
                  </div>
                  <div className="col-md-4 text-end">
                    {clientAppointmentNotesPayment?.length > 0 && (
                    <div>
                      <button className="btn btn-custom-primary me-2" onClick={() => handleSendAllNoteAsPDF(clientAppointmentNotesPayment)}>Send All notes to client</button>
                    </div>
                  )}
                  </div>
                </div>

                <div className="row mt-3 text-center">
                  <div className="col-md-6 text-start">
                    <strong>Plan Duration:</strong> {selectedClientNotesData?.start_date} - {selectedClientNotesData?.end_date}
                  </div>
                  <div className="col-md-6 text-end">
                    <strong>Amount:</strong> ${selectedClientNotesData?.amount}
                  </div>
                </div>
                {clientAppointmentNotesPayment && clientAppointmentNotesPayment.length > 0 ? (
                  <>
                  <div className="space-y-4">
                    {clientAppointmentNotesPayment.map((note) => {
                      const documentList = note.documents
                      ? note.documents.split(',').map(doc => doc.trim()).filter(Boolean)
                      : [];

                      const documentBaseUrl = process.env.REACT_APP_ATTACHMENT_NOTES_IMAGE_BACKEND_URL;

                      return (
                        <div
                          key={note.id}
                          className="border p-3 rounded-md shadow-sm bg-light mt-4"
                        >
                          <div className="d-flex justify-content-between mb-2">
                            <span><strong>Date:</strong> {note.date_of_appointment}</span>
                            <span><strong>Present:</strong> {note.present}</span>
                          </div>

                          {/* Notes Paragraph */}
                          <div className="mb-2">
                            <span><strong>Notes: </strong> {note.notes} </span>
                            {/* <p className="mb-1 mt-2">{note.notes}</p> */}
                          </div>

                          {/* Document Link */}
                          {documentList.length > 0 && (
                            <div>
                              <strong>Documents:</strong>
                              <ul className="mb-0 mt-2">
                                {documentList.map((doc, idx) => (
                                  <li key={idx} className="mt-2">
                                    <a
                                      href={`${documentBaseUrl}/${doc}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      View Document {idx + 1}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                          <div className="mt-4">
                            <button
                              className="btn btn-custom-primary"
                              onClick={() => handleSendNoteAsPDF(note)}
                            >
                              Send note to client
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </>
                ) : (
                  <p className="mt-4">No appointment notes found.</p>
                )}
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={handleCloseModal}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showClientModal && (
          <ClientDetailsModal client={selectedClient} onClose={closeClientModal} />
      )}
      {showAddModal && (
          <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" aria-modal="true" role="dialog">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="font-weight-bold text-primary font-size-24 line-hight-2 montserrat d-flex">Collect Payout</h5>
                  <button type="button" className="btn-close" onClick={handleCloseAddVideosModal} aria-label="Close"></button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="mb-3">
                      <label htmlFor="videoUrl" className="form-label text-primary mb-1 font-weight-semibold required">
                        Amount: <span class="align-items-end"> -- Available : { retrieveBalance.available[0].amount/100 } </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="amount"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="videoUrl" className="form-label text-primary mb-1 font-weight-semibold required">
                        Currency:
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="curruncy"
                        value='usd'
                        readOnly
                      />
                    </div>
                  </form>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-danger font-weight-medium font-size-16 text-capitalize px-4 rounded m-1" onClick={handleCloseAddVideosModal}>Close</button>
                  <button className="btn btn-custom-primary font-weight-medium font-size-16 text-capitalize px-4 rounded m-1" onClick={handleAddVideo}>Add</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
        </>
    );
};

export default ProviderPanelPayment;
